import CelebrationIcon from '@mui/icons-material/Celebration';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { WButton } from '@wareclouds/wareclouds-ui';

export default function TrainingResultModal({
  open,
  result,
  approvalRatePercentage,
  onAction,
}) {
  const { t } = useTranslation(['onboarding']);

  if (!result) return null;

  const isPassed = result === 'passed';

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (isPassed) return;
        onAction();
      }}
      disableEscapeKeyDown={isPassed}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            maxWidth: 400,
            width: '100%',
          },
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: 'center',
          py: 3,
          px: 3,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {isPassed ? (
            <CelebrationIcon sx={{ fontSize: 56, color: 'grey.600', mb: 2 }} />
          ) : (
            <SentimentVeryDissatisfiedIcon
              sx={{ mb: 2, fontSize: 56, color: 'grey.500' }}
            />
          )}

          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{ fontSize: 24, width: '100%' }}
          >
            {isPassed
              ? t('training.modal.passed.title')
              : t('training.modal.failed.title')}
          </Typography>

          <Typography
            variant="body1"
            component="span"
            sx={{
              mb: 2,
              color: 'text.primary',
              lineHeight: 1.6,
              width: '100%',
              display: 'block',
            }}
          >
            {isPassed ? (
              t('training.modal.passed.line1')
            ) : (
              <Trans
                i18nKey="training.modal.failed.line1"
                ns="onboarding"
                values={{ approvalRatePercentage }}
                components={[
                  <Box key="bold" component="span" sx={{ fontWeight: 700 }} />,
                ]}
              />
            )}
          </Typography>

          <Typography
            variant="body1"
            component="span"
            sx={{
              mb: 3,
              color: 'text.primary',
              lineHeight: 1.6,
              width: '100%',
              display: 'block',
            }}
          >
            {isPassed ? (
              <Trans
                i18nKey="training.modal.passed.line2"
                ns="onboarding"
                components={[
                  <Box key="bold" component="span" sx={{ fontWeight: 700 }} />,
                ]}
              />
            ) : (
              <Trans
                i18nKey="training.modal.failed.line2"
                ns="onboarding"
                components={[
                  <Box key="bold" component="span" sx={{ fontWeight: 700 }} />,
                ]}
              />
            )}
          </Typography>

          <WButton
            label={
              isPassed
                ? t('training.modal.passed.button')
                : t('training.modal.failed.button')
            }
            variant="contained"
            color="primary"
            fullWidth
            onClick={onAction}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
